<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info" style="width: 100%">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
            <BreadcrumbItem>展商证件管理</BreadcrumbItem>
          </Breadcrumb>
        </div>

        <!-- dkjaslhndklasjdlksjadlkasljdklsj555dklj -->
        <div
          class="header-tool-title"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <div style="display: flex; justify-content: center; align-items: baseline">
            <Input
              search
              placeholder="请输入公司名称"
              v-model="searchName"
              @on-search="searchAct"
              style="width: 230px; margin-top: 20px"
            />
            <el-select
              style="margin-left: 10px"
              v-model="isBoolPlant"
              @change="changeBoolPlant"
              size="small"
              clearable
              placeholder="请选择是否同步"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="product-top-r">
            <div class="product-top-r-box" @click="dialogInfo = true">
              <span class="s3">星球重新推送</span>
            </div>
            <div class="product-top-r-box" @click="hostExcelExportBack()">
              <Icon class="I1" type="icon iconfont icon-shangchuan" />
              <span class="s3">导出名单</span>
            </div>
          </div>
          <!-- <div class="product-top-r">
            <div class="product-top-r-box" @click="hostExcelExportBack()">
              <Icon class="I1" type="icon iconfont icon-shangchuan" />
              <span class="s3">导出名单</span>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="展商证" name="1">
          <excard
            v-if="String(showTabs) === '1'"
            ref="excard"
            :searchName="searchName"
            :isPlant="isBoolPlant"
          ></excard>
        </TabPane>
        <TabPane label="特邀嘉宾" name="2">
          <exspecial
            v-if="String(showTabs) === '2'"
            ref="exspecial"
            :searchName="searchName"
            :isPlant="isBoolPlant"
          ></exspecial>
        </TabPane>
        <TabPane label="海外/港澳台认证" name="3">
          <exhibitionCertEn
            v-if="String(showTabs) === '3'"
            ref="exhibitionCertEn"
            :searchName="searchName"
            :isPlant="isBoolPlant"
          ></exhibitionCertEn>
        </TabPane>
        <TabPane label="VIP" name="4">
          <excardVip
            v-if="String(showTabs) === '4'"
            ref="excardVip"
            :searchName="searchName"
            :isPlant="isBoolPlant"
          ></excardVip>
        </TabPane>
      </Tabs>
    </div>

    <!-- <el-dialog title="提示："
               :visible.sync="dialogInfo"
               width="30%"
               :close-on-click-modal="false">

      <div style="text-align: center;"
          >您确定要重新推送吗？</div>

      <span slot="footer"
            class="dialog-footer">
        <el-button type=""
                   size="small"
                   @click="dialogInfo = false">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="planetRePush()">确定</el-button>
      </span>
    </el-dialog> -->

    <iModal
      v-model="dialogInfo"
      :mask-closable="false"
      title="提示："
      width="800"
      @on-ok="planetRePush"
      @on-cancel="dialogInfo = false"
    >
      <div style="text-align: center">您确定要重新推送吗？</div>
    </iModal>
  </div>
</template>

<script>
import excard from "./componentsManage/exhibition-card";
import excardVip from "./componentsManage/exhibition-card-vip";
import exspecial from "./componentsManage/exhibition-special-guests";
import exhibitionCertEn from "./componentsManage/exhibition-cret-En";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      dialogInfo: false,
      addShow: false,
      showTabs: "1",
      searchName: "",
      modal1: false,
      disabled: true, //是否禁用上传文件按钮
      isBoolPlant: "",

      options: [
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
    };
  },
  components: {
    excard,
    excardVip,
    exspecial,
    exhibitionCertEn,
  },
  computed: {
    ...mapGetters({
      hostExhibitionId: "hostSetModule/getHostExhibitionId",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 展商证管理";
  },
  methods: {
    ...mapActions({
      DeExCardUpExcelExportDeexCard: "exhibitionModule/DeExCardUpExcelExportDeexCard",
      getLocalResetPush: "hostSetModule/getLocalResetPush",
      addTask: "hostCommonModule/addTask",
    }),

    switchBrand() {},

    changeBoolPlant(val) {
      console.log(val, "00000000000");
      this.isBoolPlant = val;

      this.$nextTick(() => {
        this.searchAct();
      });
    },

    searchAct() {
      if (this.showTabs == "1") {
        this.$refs["excard"].searchAct();
      } else if (this.showTabs == "2") {
        this.$refs["exspecial"].searchAct();
      } else if (this.showTabs == "3") {
        this.$refs["exhibitionCertEn"].searchAct();
      } else if (this.showTabs == "4") {
        this.$refs["excardVip"].searchAct();
      }
    },

    async hostExcelExportBack() {
      let badgeType = "";
      if (this.showTabs == "1") {
        badgeType = "展商证";
      } else if (this.showTabs == "2") {
        badgeType = "特邀嘉宾";
      } else if (this.showTabs == "3") {
        badgeType =
          "海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor";
      } else if (this.showTabs == "4") {
        badgeType = "VIP";
      }

      let opt = {
        opt: {
          sorts: [{ propertyName: "inTime", ascending: false }],
          exhibitionId: this.exhibitionInfo.id,
          companyName: this.searchName,
        },
        badgeType: badgeType,
      };

      let req = {
        taskType: 11,
        taskName: this.exhibitionInfo.name + "-" + opt.badgeType,
        exhibitionId: this.exhibitionInfo.id,
        searchCondition: JSON.stringify(opt.opt),
      };

      let bool = await this.addTask(req);
      if (bool && bool.successed) {
        this.$Message.success("创建成功！");
        this.$router.push("/host/index/ex/certApplyManageExport");
      } else {
        this.$Message.success("创建失败，请重新尝试");
      }

      //       exhibitionId
      // :
      // "39eb2110-203f-4036-ad52-27b345b5129c"
      // searchCondition
      // :
      // "{\"Name\":\"测试\"}"
      // taskName
      // :
      // "第93届中国国际医疗器械（春季）博览会产品表格搜索结果和图片导出"
      // taskType
      // :
      // 0

      //   let opt = {
      //     opt: {
      //       sorts: [{ propertyName: "inTime", ascending: false }],
      //       exhibitionId: this.exhibitionInfo.id,
      //       badgeType: badgeType,
      //       companyName: this.searchName,
      //     },
      //     badgeType: badgeType,
      //   };

      //   let data = await this.DeExCardUpExcelExportDeexCard(opt);
    },

    async planetRePush() {
      let data = await this.getLocalResetPush(this.exhibitionInfo.id);
      if (data) {
        this.dialogInfo = false;
        this.$Message.success("推送成功");
      } else {
        this.$Message.error("推送失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
  /deep/ {
    .ivu-tabs-tab {
      font-size: 24px;
      font-weight: bold;
    }
  }
}

.product {
  &-top {
    min-width: 650px;
    display: flex;
    justify-content: space-between;
    padding: 18px 25px 18px 35px;
    background-color: #fff;
    &-l {
      width: 400px;
      &-title {
        margin-top: 20px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      &-text {
        font-size: 14px;
        color: #333;
        padding-top: 24px;
      }
    }
    &-r {
      height: 100%;
      display: flex;
      align-items: flex-end;
      padding-bottom: 15px;
      padding-right: 25px;
      &-box {
        width: 150px;
        height: 80px;
        border: 2px dotted #f00;
        background-color: #ffe6e3;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 20px;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #f00;
        }
        .s3 {
          font-size: 14px;
          color: #f00;
          margin-left: 9px;
        }
      }
    }
  }
}
</style>
